<template>
    <div id="desktop-nav"
         :class="{'solid': this.showSolid}">
        <div id="nav">
            <transition name="circle">
                <div v-if="frontPage"
                     id="circle-nav">
                    <img class="lg"
                         alt="MOCO Ink logo"
                         src="../assets/logo.png"/>
                    <div id="logo-text">
                        {{this.$lang.homeSubtitle}}
                    </div>
                </div>
            </transition>
            <router-link to="/"
                         v-show="!frontPage">
                <img class="sm"
                     alt="MOCO Ink logo"
                     src="../assets/logo.png"/>
                {{this.$lang.appName}}
            </router-link>
            <a :class="{'nav-expand': true,
                        'expanded': !this.frontPage}">
                {{this.$lang.homeSubtitle}}
            </a>
            <router-link to="/catalog"
                         @mouseenter.native="showDetailCard"
                         @mouseleave.native="hideDetailCard"
                         @click.native="hideDetailCard">
                {{this.$lang.navCatalog}}
            </router-link>
            <router-link to="/support">
                {{this.$lang.navSupport}}
            </router-link>
            <router-link to="/blog">
                {{this.$lang.navBlog}}
            </router-link>
            <router-link to="/about">
                {{this.$lang.navAbout}}
            </router-link>
            <a class="nav-disabled">
                {{this.$lang.navShop}}
            </a>
            <a class="nav-lang"
               :class="{'router-link-exact-active': langSelectorShown}"
               @click="toggleLangSelector">
                Language
                <div id="nav-lang-selector"
                     :class="{'hidden': !langSelectorShown}">
                    <div v-for="(lang, index) in langList" :key="lang">
                        <div class="button flat-button" @click="changeLanguage(index)">{{lang}}</div>
                    </div>
                </div>
            </a>
        </div>
        <NavigationMenu :class="{'hidden': !detailCardShown}"
                        id="nav-menu"
                        :data="dbData.categories"
                        :dismiss-handle="hideDetailCard"
                        @mouseenter.native="showDetailCard"
                        @mouseleave.native="hideDetailCard"/>
    </div>
</template>

<script>
	import NavigationMenu from "@/components/NavigationMenu";
	import LanguageService from "@/services/LanguageService";

	export default {
		name: "DesktopNav",
		components: {NavigationMenu},
		props: {
			dbData: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				langSelectorShown: false,
				langList: LanguageService.getNames(),
				detailCardShown: false,
				throttledScrollTop: 0
			}
		},
		computed: {
			frontPage() {
				return false;
				//return this.$route.meta.index === 0 &&
				//	this.throttledScrollTop < (window.innerHeight - 240);
			},
            showSolid() {
				return !this.frontPage && this.throttledScrollTop > 0.35 * window.innerHeight;
            }
		},
		created() {
			window.addEventListener("scroll", this.$throttle(this.onScroll, 75));
		},
		methods: {
			toggleLangSelector() {
				this.langSelectorShown = !this.langSelectorShown;
			},
			showDetailCard() {
				this.detailCardShown = true;
				this.langSelectorShown = false;
			},
			hideDetailCard() {
				this.detailCardShown = false;
			},
			changeLanguage(id) {
				LanguageService.setLanguage(id);
				/* ideally we really shouldn't need to refresh the page */
				this.$router.go(0);
			},
            onScroll() {
				this.throttledScrollTop = window.top.scrollY;
            }
		}
	}
</script>

<style scoped lang="scss">

    #circle-nav {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: -160px;
        height: 100vw;
        max-height: 1200px;
        box-sizing: border-box;
        padding-bottom: 56px;
        border-radius: 50vw;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        background-color: transparentize($p-bg, 0.2);
        transform: translateZ(0px);
    }

    @supports (backdrop-filter: blur(32px)) or (-webkit-backdrop-filter: blur(32px)) {
        #circle-nav {
            background-color: transparentize($p-bg, 0.5);
            backdrop-filter: blur(32px);
        }
    }

    #circle-nav::before {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border: solid $p-accent 8px;
        border-radius: 50vw;
        clip-path: polygon(0 calc(100% - 160px), 0 100%, 100% 100%, 100% calc(100% - 160px));
    }

    #logo-text {
        font-size: 20px;
        font-family: $serif;
        z-index: 1;
    }

    .circle-enter-active, .circle-leave-active {
        transition: opacity 0.5s $bezier, transform 0.5s $bezier;
    }

    .circle-enter, .circle-leave-to {
        opacity: 0;
        transform: translateZ(0) translateY(-90px) !important;

        img.lg {
            opacity: 0;
            transform: translateX(calc(#{"max(-50vw, -600px)"} - 16px));
        }
    }

    #desktop-nav {
        position: fixed;
        z-index: 3;
        width: 100%;
        height: 64px;
    }

    #desktop-nav.solid {
        background-color: $p-bg;
    }

    #nav {
        position: relative;
        margin: 0 auto;
        max-width: 1200px;
        width: 100%;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        box-sizing: border-box;
        user-select: none;
    }

    a {
        position: relative;
        text-decoration: none;
        height: 64px;
        line-height: 60px;
        box-sizing: border-box;
        color: $p-fg;
        padding: 0 16px;
        border: solid transparent 2px;
        z-index: 2;
        font-family: $serif;
        cursor: pointer;
        @extend .flat-button;
    }

    a:hover {
        border-bottom: $solid;
    }

    a:active {
        @extend .flat-button:active;
    }

    img.lg {
        height: 48px;
        z-index: 1;
        transition: transform 0.5s $bezier, opacity 0.3s $bezier;
    }

    img.sm {
        position: relative;
        height: 20px;
        vertical-align: middle;
        margin-right: 5px;
        top: -2px;
    }

    a.nav-expand {
        background-color: unset;
        cursor: default;
        transition: all 0.5s $bezier;
        flex-grow: 0.00001;
        padding: 0;
        border: none;
        line-height: 64px;
    }

    a.nav-expand:active {
        color: unset;
    }

    .nav-expand.expanded {
        flex-grow: 1;
    }

    a.nav-disabled {
        color: $d-fg;
        border-color: transparent;
    }

    a:first-child {
        font-weight: 700;
        box-shadow: none;
        border: solid 3px transparent;
    }

    a.router-link-exact-active {
        border-bottom: solid 2px $p-fg;
    }

    #nav-lang-selector {
        position: absolute;
        top: 64px;
        left: 0;
        padding: 5px 10px;
        clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
        transition: clip-path 0.2s $bezier;
        @extend %dotted-box;
        @include msBad {
            transition: opacity 0.2s;
        }
    }

    #nav-lang-selector.hidden {
        clip-path: polygon(0% 0%, 0% 0%, 100% 0%, 100% 0%);
        @include msBad {
            pointer-events: none;
            opacity: 0;
        }
    }

    #nav-lang-selector .button {
        height: 20px;
        line-height: 20px;
        padding: 5px 10px;
        margin: 5px 0 5px 0;
    }

    #nav-menu {
        overflow: hidden;
        box-sizing: border-box;
        transition: clip-path 0.5s;
        transition-delay: 0.1s;
        transition-timing-function: $bezier;
        clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
        @include msBad {
            transition: opacity 0.2s;
        }
    }

    #nav-menu.hidden {
        pointer-events: none;
        transition-delay: 0s;
        clip-path: polygon(0% 0%, 0% 0%, 100% 0%, 100% 0%);
        @include msBad {
            pointer-events: none;
            opacity: 0;
        }
    }

</style>